import { _ as s } from "./index.es284.js";
import { i as t } from "./index.es285.js";
import { i as o } from "./index.es265.js";
var a = s, e = t, m = o, i = a ? a.isConcatSpreadable : void 0;
function n(r) {
  return m(r) || e(r) || !!(i && r && r[i]);
}
var _ = n;
export {
  _
};
//# sourceMappingURL=index.es109.js.map
